<template>
    <modal :adaptive="true" ref="error" height="auto" name="error">
        <d-container fluid class="mb-3">
            <d-col class="mt-5 mb-3 d-flex justify-content-center">
                <i class="material-icons clear">clear</i>
            </d-col>
            <d-col class="mb-3">
                <h3 class="text-center">We have a problem</h3>
            </d-col>
            <d-col class="mb-3">
                <h6 class="text-center">The app needs access to <a href="https://ads.microsoft.com">https://ads.microsoft.com</a>. If you use a work account contact your IT Admin to review the configuration of your service subscriptions.</h6>
            </d-col>
            <d-col class="d-flex justify-content-center">
                <button @click="hide" class="mt-3 ml-3 btn btn-success btn-sm">OK</button>
            </d-col>
        </d-container>
    </modal>
</template>

<script>
    export default {
        methods: {
            hide() {
                this.$modal.hide('error')
                this.$router.push('/')
            }
        },

        mounted() {
            if (this.$route.query.error) {
                this.$refs.error.visible = true
            }
        }
    };
</script>